import Vue from "vue";
import Router from "vue-router";
import Layout from "@/components/Layout/Layout";
import Index from "@/pages/Index";
/**
 * dashboard page
 */
import Dashboard from "@/pages/Home/Dashboard";
//Invoice
import FilterCreate from "@/pages/Filtercreate";
/**
 * customer pages
 */
import Customer from "@/pages/Customer/Customer";
import CustomerCreate from "@/pages/Customer/Create";
import CustomerView from "@/pages/Customer/View";
import CustomerImport from "@/pages/Customer/Import";

/**
 * receive paymetn pages
 */
import Banking from "@/pages/Banking/Banking";
import BankingCreate from "@/pages/Banking/BankingForm";
import BankingUpdate from "@/pages/Banking/BankingForm";


/**
 * product pages
 */
import Product from "@/pages/Product/Product";
import Productsku from "@/pages/Product/Productsku";
import ProductCreate from "@/pages/Product/Create";
import ProductUpdate from "@/pages/Product/Update";
import ProductView from "@/pages/Product/View";
import ProductImport from "@/pages/Product/Import";
/**
 * product pages
 */
import PriceList from "@/pages/Product/PriceList/PriceList";
import PriceListCreate from "@/pages/Product/PriceList/Create";
import PriceListUpdate from "@/pages/Product/PriceList/Update";
/**
 * sales pages
 */
import Sales from "@/pages/Sales/Sales";
import SalesCreate from "@/pages/Sales/Create";
import SalesUpdate from "@/pages/Sales/Update";
import SalesView from "@/pages/Sales/View";
/**
 * invoice pages
 */
import Invoice from "@/pages/Invoice/Invoice";
import InvoiceCreate from "@/pages/Invoice/Create";
import InvoiceUpdate from "@/pages/Invoice/Update";
import InvoiceView from "@/pages/Invoice/View";
import InvoicePayment from "@/pages/Invoice/Payment";
/**
 * amc pages
 */
import AmcService from "@/pages/Amc/AmcService/AmcService";
import AmcServiceCreate from "@/pages/Amc/AmcService/Create";
import AmcServiceUpdate from "@/pages/Amc/AmcService/Update";
import AmcServiceView from "@/pages/Amc/AmcService/View";
import AmcContract from "@/pages/Amc/AmcContract/AmcContract";
import AmcContractCreate from "@/pages/Amc/AmcContract/Create";
import AmcContractUpdate from "@/pages/Amc/AmcContract/Update";
import AmcContractView from "@/pages/Amc/AmcContract/View";
import AmcContractRecordService from "@/pages/Amc/AmcContract/Service";
import AmcInvoice from "@/pages/Amc/AmcContract/AmcInvoice";

/**
 * credit note pages
 */
import Credit from "@/pages/Credit/Credit";
import CreditCreate from "@/pages/Credit/Create";
import CreditUpdate from "@/pages/Credit/Update";
import CreditRefund from "@/pages/Credit/Refund";
import CreditView from "@/pages/Credit/View";
/**
 * receive paymetn pages
 */
import Payment from "@/pages/Payment/Payment";
import PaymentCreate from "@/pages/Payment/Create";
import PaymentUpdate from "@/pages/Payment/Update";
import PaymentRefund from "@/pages/Payment/Refund";
import PaymentView from "@/pages/Payment/View";
/**
 * customer advance pages
 */
import CustomerAdvance from "@/pages/CustomerAdvance/CustomerAdvance";
import CustomerAdvanceCreate from "@/pages/CustomerAdvance/Create";
import CustomerAdvanceUpdate from "@/pages/CustomerAdvance/Update";
import CustomerAdvanceRefund from "@/pages/CustomerAdvance/Refund";
import CustomerAdvancePaymentForm from "@/pages/CustomerAdvance/Payment";
import CustomerAdvanceView from "@/pages/CustomerAdvance/View";
/**
 * Invoice Reports pages
 */
import Reports from "@/pages/Reports/Reports";
import SalesPerson from "@/pages/Reports/Sales/SalesPerson/Index";
import SalesItem from "@/pages/Reports/Sales/Products/Index";
import SalesCustomer from "@/pages/Reports/Sales/Customer/Index";
import SalesPersonFilter from "@/pages/Reports/Sales/SalesPerson/Filter";
import SalesItemFilter from "@/pages/Reports/Sales/Products/Filter";
import SalesCustomerFilter from "@/pages/Reports/Sales/Customer/Filter";
import PaymentReport from "@/pages/Reports/Payment";
import InvoiceReport from "@/pages/Reports/Invoices";
import EstimateReport from "@/pages/Reports/Estimate";
import AgingDetailsReport from "@/pages/Reports/AgingDetails";
import CreditNoteDetailsReport from "@/pages/Reports/CreditNoteDetails";
import RetainerInvoiceDetailsReport from "@/pages/Reports/RetainerInvoiceDetails";
import CustomerBalancesReport from "@/pages/Reports/CustomerBalances/Index";
import CustomerBalancesFilter from "@/pages/Reports/CustomerBalances/Filter";
import PaymentsReceivedReport from "@/pages/Reports/PaymentsReceived";
import RefundHistoryReport from "@/pages/Reports/RefundHistory";
import RecurringInvoiceReport from "@/pages/Reports/RecurringInvoice";
import AmcContractReport from "@/pages/Reports/AmcContract";
import TDSDetailsReport from "@/pages/Reports/TDSDetails/Index";
import TDSDetailsFilter from "@/pages/Reports/TDSDetails/Filter";
import BankChargesReport from "@/pages/Reports/BankCharges/Index";
import BankChargesFilter from "@/pages/Reports/BankCharges/Filter";
import TaxSummary from "@/pages/Reports/Taxes/TaxSummary";
import TaxDetails from "@/pages/Reports/Taxes/Details";

/**
 * gst filing Reports pages
 */
import GSTR1Overview from "@/pages/Gstfiling/Overview";
import GSTR1Transaction from "@/pages/Gstfiling/Transactions";
//retainer invoice
import RetainerInvoice from "@/pages/RetainerInvoice/RetainerInvoice";
import RetainerInvoiceCreate from "@/pages/RetainerInvoice/Create";
import RetainerInvoiceUpdate from "@/pages/RetainerInvoice/Update";
import RetainerPaymentForm from "@/pages/RetainerInvoice/Payment";
import RetainerInvoiceView from "@/pages/RetainerInvoice/View";
import RetainerInvoiceRefund from "@/pages/RetainerInvoice/Refund";
//  recurring invoice
import RecurringInvoice from "@/pages/RecurringInvoice/RecurringInvoice";
import RecurringInvoiceCreate from "@/pages/RecurringInvoice/Create";
import RecurringInvoiceUpdate from "@/pages/RecurringInvoice/Update";
import RecurringInvoiceView from "@/pages/RecurringInvoice/View";
/**
 * settings view page
 */
/**
 * user role page
 */
import UserTheme from "@/pages/Settings/Users/Theme/Theme";
import UserRole from "@/pages/Settings/Users/UserRole/UserRole";
import UserRoleCreate from "@/pages/Settings/Users/UserRole/Create";
import UserRoleUpdate from "@/pages/Settings/Users/UserRole/Update";


import AccountSettings from "@/pages/Settings/Account/Account";


//  invoice settigns page
import InvoiceSettings from "@/pages/Settings/Invoice/Index"
import InvoicePrintSettings from "@/pages/Settings/Invoice/Print"
import QuotationPrintSettings from "@/pages/Settings/Invoice/Quotationprint"
import StatementPrintSettings from "@/pages/Settings/Invoice/Customerprint"
import CreditPrintSettings from "@/pages/Settings/Invoice/Creditprint"

import TemplateUpdate from "@/pages/Settings/Invoice/Templateupdate"
import Templates from "@/pages/Settings/Invoice/Templates"
import RetailTemplatesUpdate from "@/pages/Settings/Invoice/Retailtemp"
import CustomerTemplateUpdate from "@/pages/Settings/Invoice/Customertemplate"
import QuotationSettings from "@/pages/Settings/Invoice/Quotation"
import CreditSettings from "@/pages/Settings/Invoice/Credit"
import CustomerStatement from "@/pages/Settings/Invoice/Customer"
import ProductSettings from "@/pages/Settings/Invoice/Product"
import RetainerSettings from "@/pages/Settings/Invoice/Retainer"
import AmcSettings from "@/pages/Settings/Invoice/Amc"
import PaymentSettings from "@/pages/Settings/Invoice/Payment"
import CustomerAdvanceSettings from "@/pages/Settings/Invoice/CustomerAdvance"
import RecurringSettings from "@/pages/Settings/Invoice/Recurring"
import Settings from "@/pages/Settings/Invoice/Settings"
import OpeningBalance from "@/pages/Settings/OpeningBalance/OpeningBalance"
import OpeningBalanceImport from "@/pages/Settings/OpeningBalance/Import"
//  tax group settings
import TaxGroup from "@/pages/Settings/TaxGroup/TaxGroup"
//  Reporting Tag settings
import ReportingTag from "@/pages/Settings/ReportingTag/ReportingTag"
//Email page

import Email from "@/pages/Email/Email"
import Currency from "@/pages/Settings/Currency/Currency"
import ExchangeRateImport from "@/pages/Settings/Currency/Import";

import ExchangeRate from "@/pages/Settings/Currency/ExchangeRate"
/**
 * discount coupon module
 */
// import DiscountCoupon from "@/pages/DiscountCoupon/DiscountCoupon";
// import DiscountCouponCreate from "@/pages/DiscountCoupon/Create";
// import DiscountCouponUpdate from "@/pages/DiscountCoupon/Update";
/**
 * no found page
 */
import Error from "@/pages/Error/Error";
import PermissonDenied from "@/pages/Error/Error500";
/**
 * state mangement js
 */
import store from "@/store/index"; // <--- Include our store

//Mail
import EmailSettings from "@/pages/Settings/EmailSettings/EmailSettings"
import EmailCreate from "@/pages/Settings/EmailSettings/Email"

Vue.use(Router);
// customer route
export const customer = [{
    path: "customer",
    name: "Customer",
    component: Customer,
    meta: {
      isheader: true,
      role: 'private',
      id: 2,
      page: 'customer',
      action: 'index',
      title: 'Customers',
      icon: "fi flaticon-users",
      affix: true,
      hasChildren: false,
      hasParents: false,
      search: true
    },
    props: true
  },
  {
    path: "customer/create",
    name: "CustomerCreate",
    component: CustomerCreate,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      if (routeTo.query.clone_id) {
        store
          .dispatch("customer/fetchList", {
            id:parseInt(routeTo.query.clone_id),
            type:'clone'}
)
          .then(list => {

            routeTo.params.list = list; // <--- Set the event we retrieved
            next();
          })
          .catch(() => {});
      } else {
        next();
      }
    },
    meta: {
      isheader: true,
      role: 'private',
      title: 'Add New | Customers',
      icon: "",
      page: 'customer',
      action: 'create',
      affix: false,
      search: false
    },
    props: true
  },
  {
    path: "customer/update/:id",
    name: "CustomerUpdate",
    component: CustomerCreate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded    
      store
        .dispatch("customer/fetchList", {
          id:parseInt(routeTo.params.id),
          type:'update'}
)
        .then(list => {

          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});

    },
    meta: {
      isheader: true,
      role: 'private',
      title: 'Customers',
      page: 'customer',
      action: 'update',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "customer/view/:id",
    name: "CustomerView",
    component: CustomerView,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("customer/fetchViewList", parseInt(routeTo.params.id))
        .then(list => {

          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        store
        .dispatch("settings/fetchinvoicesettings", {
          stg_menu: "Customer",
          stg_name: "cus_settings_details"
        })
        .then(() => {
          next();
        })

        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      title: 'Customers',
      page: 'customer',
      action: 'index',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "customer/import",
    name: "CustomerImport",
    component: CustomerImport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'customer',
      action: 'create',
      title: 'Import | Customers',
      icon: "",
      affix: false,
      search: false
    },
  },
  //Email
  {
    path: "email/email",
    name: "Email",
    component: Email,
    props: true,
    meta: {
      isheader: true,
      role: 'public',
      page: 'email',
      action: 'email',
      title: 'Emails',
      icon: "",
      affix: false,
      search: false
    },
  }
];
export const pricelist = [{
    path: "product/pricelist",
    name: "PriceList",
    component: PriceList,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      id: 3,
      page: 'pricelists',
      action: 'index',
      title: 'Price Lists',
      icon: "fi flaticon-controls-4",
      affix: true,
      hasChildren: false,
      hasParents: false,
      search: true
    }
  },
  //end
  {
    path: "product/pricelist/update/:id",
    name: "PriceListUpdate",
    component: PriceListUpdate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("pricinglist/fetchList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'pricelists',
      action: 'update',
      title: 'Price Lists',
      icon: "",
      affix: false,
      search: false
    },

  },
  {
    path: "product/pricelist/create",
    name: "PriceListCreate",
    component: PriceListCreate,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      title: 'Add New | Price Lists',
      page: 'pricelists',
      action: 'create',
      icon: "",
      affix: false,
      search: false
    },
  }
];
// product route
export const product = [{
    path: "product/product",
    name: "Product",
    component: Product,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      id: 4,
      page: 'product',
      action: 'index',
      title: 'Products',
      icon: "la la-cube la-lg",
      affix: true,
      hasChildren: false,
      hasParents: true,
      search: true
    }
  },
  {
    path: "product/product/Productsku",
    name: "Productsku",
    component: Productsku,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'product',
      action: 'index',
      title: 'Products',
      icon: "",
      affix: false,
      search: false
    }

  },
  {
    path: "product/product/create",
    name: "ProductCreate",
    component: ProductCreate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
     
      if (routeTo.query.clone_id) {
        store
          .dispatch(
            "products/fetchList",
            {
              id: parseInt(routeTo.query.clone_id),
              type:'clone'
            })
          .then(() => {
            next();
          })
          .catch(() => {});
      }
      
      
      else {
        next();
      }
    },
    meta: {
      isheader: true,
      role: 'private',
      title: 'Add New | Products',
      page: 'product',
      action: 'create',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "product/product/import",
    name: "ProductImport",
    component: ProductImport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'product',
      action: 'create',
      title: 'Import | Products',
      icon: "",
      affix: false,
      search: false
    },
  },
  //end
  {
    path: "product/product/update/:id",
    name: "ProductUpdate",
    component: ProductUpdate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
          .dispatch(
            "products/fetchList",
            {
              id: parseInt(routeTo.params.id),
              type:'update'
            })
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved

          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'product',
      action: 'update',
      title: 'Products',
      icon: "",
      affix: false,
      search: false
    },

  },
  {
    path: "product/product/view/:id",
    name: "ProductView",
    component: ProductView,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("products/fetchViewList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'product',
      action: 'index',
      title: 'Products',
      icon: "",
      affix: false,
      search: false
    },

  }
];
//  retainer route
export const retainerinvoice = [ //retainer invoice
  {
    path: "retainerinvoice",
    name: "RetainerInvoice",
    component: RetainerInvoice,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'index',
      title: 'Customer Deposits',
      icon: "fi flaticon-save",
      affix: true,
      hasChildren: false,
      hasParents: true,
      search: true
    },
  },
  {
    path: "retainerinvoice/create",
    name: "RetainerInvoiceCreate",
    component: RetainerInvoiceCreate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      if (routeTo.query.quot_id) {
        store
          .dispatch("retainer/fetchQuotDetails", parseInt(routeTo.query.quot_id))
          .then(list => {
            routeTo.params.list = list; // <--- Set the event we retrieved
            next();
          })
          .catch(() => {});
      } else if (routeTo.query.customer_id) {
        // before this route is loaded
        store
          .dispatch("customer/fetchViewList", parseInt(routeTo.query.customer_id))
          .then(() => {

            next();
          })
          .catch(() => {});
      } else {
        next()
      }
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'create',
      title: 'Add New | Customer Deposits',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "retainerinvoice/payment/:id",
    name: "RetainerPaymentForm",
    component: RetainerPaymentForm,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'create',
      title: 'Customer Deposit Payments',
      icon: "",
      affix: false,
      search: false
    },
  },

  //  payment update
  {
    path: "retainerinvoice/update/:id",
    name: "RetainerInvoiceUpdate",
    component: RetainerInvoiceUpdate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("retainer/fetchList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      id: 6,
      page: 'paymentsreceived',
      action: 'update',
      title: 'Customer Deposits',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "retainerinvoice/view/:id",
    name: "RetainerInvoiceView",
    component: RetainerInvoiceView,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("retainer/fetchviewList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        store
        .dispatch("settings/fetchinvoicesettings", {
          stg_menu: "Customer Deposit",
          stg_name: "retainer_settings_details"
        })
        .then(() => {
          next();
        })
  
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'index',
      title: 'Customer Deposits',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "retainerinvoice/refund/:id",
    name: "RetainerInvoiceRefund",
    component: RetainerInvoiceRefund,
    props: true,
    meta: {
      isheader: true,
      role: 'public',
      page: 'paymentsreceived',
      action: 'update',
      title: 'Customer Deposit Refunds',
      icon: "",
      affix: false,
      search: false
    },
  },
]
//  quotation route
export const quotation = [

  {
    path: "sales",
    name: "Sales",
    component: Sales,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      end: true,
      id: 4,
      page: 'quotation',
      action: 'index',
      title: 'Quotations',
      icon: "fi flaticon-paper-plane",
      affix: true,
      hasChildren: false,
      hasParents: true,
      search: true
    },
  },
  {
    path: "sales/create",
    name: "SalesCreate",
    component: SalesCreate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      if (
        routeTo.query.clone_id
      ) {
        // before this route is loaded
        store
        .dispatch("sales/fetchList", {
          id: parseInt(routeTo.query.clone_id),
          page: 'clone_id',
          type:'clone'
        })
          .then(() => {
            next();
          })
          .catch(() => {});
      } else if (routeTo.query.customer_id) {

        store
          .dispatch("customer/fetchViewList", parseInt(routeTo.query.customer_id))
          .then(() => {
            next();
          })
          .catch(() => {});
      } else {
        next();
      }
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'quotation',
      action: 'create',
      title: 'Add New | Quotations',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "sales/update/:id",
    name: "SalesUpdate",
    component: SalesUpdate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
      .dispatch("sales/fetchList", {
        id:parseInt(routeTo.params.id),
        page: 'update',
        type:'update'
      })

        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'quotation',
      action: 'update',
      title: 'Quotations',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "sales/view/:id",
    name: "SalesView",
    component: SalesView,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("sales/fetchviewList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        store
        .dispatch("settings/fetchinvoicesettings", {
          stg_menu: "Sales",
          stg_name: "quot_settings_details"
        })
        .then(() => {
          next();
        })
  
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'quotation',
      action: 'index',
      title: 'Quotations',
      icon: "",
      affix: false,
      search: false
    },
  }
];
//  amc service
export const amcservice = [{
    path: "product/bundle",
    name: "AmcService",
    component: AmcService,
    props: true,

    meta: {
      isheader: true,
      role: 'private',
      page: 'amcservice',
      action: 'index',
      title: 'Product Bundles',
      icon: "fi flaticon-network",
      affix: true,
      hasChildren: false,
      hasParents: true,
      search: true
    },
  },
  {
    path: "product/bundle/create",
    name: "AmcServiceCreate",
    component: AmcServiceCreate,
    props: true,

    beforeEnter(routeTo, routeFrom, next) {
      if (
        routeTo.query.clone_id
      ) {
        // before this route is loaded
        store
          .dispatch("amcservice/fetchAmcServiceList",  {
            id: parseInt(routeTo.query.clone_id),
            type:'clone'
          })
          .then(() => {
            next();
          })
          .catch(() => {});
      } else {
        next();
      }
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'amcservice',
      action: 'create',
      title: 'Add New | Amc services',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "product/bundle/update/:id",
    name: "AmcServiceUpdate",
    component: AmcServiceUpdate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {

      // before this route is loaded
      store
        .dispatch("amcservice/fetchAmcServiceList", {
          id: parseInt(routeTo.params.id),
          type:'update'
        })
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'amcservice',
      action: 'update',
      title: 'Update | Amc Services',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "product/bundle/view/:id",
    name: "AmcServiceView",
    component: AmcServiceView,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("amcservice/fetchViewList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          store
          .dispatch("settings/fetchinvoicesettings", {
            stg_menu: "Product",
            stg_name: "pdt_settings_details"
          });
          next();
        })
        .catch(() => {});
    },

    meta: {
      isheader: true,
      role: 'private',
      page: 'amcservice',
      action: 'index',
      title: 'Product Bundles',
      icon: "",
      affix: false,
      search: false
    },

  },
]
// amc contract
export const amccontract = [{
    path: "amc/amccontract",
    name: "AmcContract",
    component: AmcContract,
    props: true,

    meta: {
      isheader: true,
      role: 'private',
      page: 'amccontract',
      action: 'index',
      title: 'AMC Contracts',
      icon: "fi flaticon-network",
      affix: true,
      hasChildren: false,
      hasParents: true,
      search: true
    },
  },
  {
    path: "amc/amccontract/create",
    name: "AmcContractCreate",
    component: AmcContractCreate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      if (routeTo.query.customer_id) {

        store
          .dispatch("customer/fetchViewList", parseInt(routeTo.query.customer_id))
          .then(() => {
            next();
          })
          .catch(() => {});
      } else {
        next();
      }

    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'amccontract',
      action: 'create',
      title: 'Add New | Amc Contracts',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "amc/amccontract/update/:id",
    name: "AmcContractUpdate",
    component: AmcContractUpdate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
      .dispatch("amccontract/fetchAmcContractList", {
        id: parseInt(routeTo.params.id),
        page: 'update',
        type:'update'
      })
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'amccontract',
      action: 'update',
      title: 'Amc Contracts',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "amc/amccontract/view/:id",
    name: "AmcContractView",
    component: AmcContractView,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("amccontract/fetchAmcContractView", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'amccontract',
      action: 'index',
      title: 'Amc Contracts',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "amc/amccontract/invoice/:id",
    name: "AmcInvoice",
    component: AmcInvoice,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("invoice/fetchAmcContractInvoiceList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {

      isheader: true,
      role: 'private',
      page: 'amccontract',
      action: 'create',
      title: 'Amc Invoices',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "amc/amccontract/recordservice/:id",
    name: "AmcContractRecordService",
    component: AmcContractRecordService,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'amccontract',
      action: 'update',
      title: 'Amc Contracts',
      icon: "",
      affix: false,
      search: false
    },
  }
]
//  invoice route
export const invoice = [ //  Invoice menu
  {
    path: "invoice",
    name: "Invoice",
    component: Invoice,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'invoice',
      action: 'index',
      id: 5,
      title: 'Invoices',
      icon: "fi flaticon-file",
      affix: true,
      hasChildren: false,
      hasParents: true,
      search: true
    },
  },
  {
    path: "invoice/create",
    name: "InvoiceCreate",
    component: InvoiceCreate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      if (routeTo.query.clone_id) {
        store
          .dispatch(
            "invoice/fetchInvoiceList",
            {
              id: parseInt(routeTo.query.clone_id),
              page: 'clone_id',
              type:'clone'
            })
          .then(() => {
            next();
          })
          .catch(() => {});
      } else if (routeTo.query.quotation) {
        store
          .dispatch(
            "invoice/quotationtoinvoice",
            parseInt(routeTo.query.quotation)
          )
          .then(() => {
            next();
          })
          .catch(() => {});

      } else if (routeTo.query.customer_id) {
        store
          .dispatch(
            "customer/fetchViewList",
            parseInt(routeTo.query.customer_id)
          )
          .then(() => {
            next();
          })
          .catch(() => {});
      } else if (routeTo.query.recurring_inv_id) {
        store
          .dispatch(
            "invoice/fetchRecurringList",
            parseInt(routeTo.query.recurring_inv_id)
          )
          .then(list => {
            routeTo.params.list = list;
            next();
          })
          .catch(() => {});
      } else {
        next();
      }
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'invoice',
      action: 'create',
      title: 'Add New | Invoices',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "invoice/update/:id",
    name: "InvoiceUpdate",
    component: InvoiceUpdate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("invoice/fetchInvoiceList",
        {
          id: parseInt(routeTo.params.id),
          page: routeTo.query.sales_order ? 'order' : '',
          type:'update'
        }
        )
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'invoice',
      action: 'update',
      title: 'Invoices',
      icon: "",
      affix: false,
      search: false
    },
  },

  {
    path: "invoice/payment/:id",
    name: "InvoicePayment",
    component: InvoicePayment,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("invoice/fetchList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'create',
      title: 'Payments Received',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "invoice/view/:id",
    name: "InvoiceView",
    component: InvoiceView,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("invoice/fetchList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'invoice',
      action: 'index',
      title: 'Invoices',
      icon: "",
      affix: false,
      search: false
    },
  },
]
//  recurring route
export const recurringinvoice = [ //  recurring invoice
  {
    path: "recurringinvoice",
    name: "RecurringInvoice",
    component: RecurringInvoice,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'recurringinvoice',
      action: 'index',
      id: 9,
      title: 'Recurring Invoices',
      icon: "fi flaticon-equal-1",
      affix: true,
      hasChildren: false,
      hasParents: true,
      search: true
    },
  },
  {
    path: "recurringinvoice/view/:id",
    name: "RecurringInvoiceView",
    component: RecurringInvoiceView,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("recurringinvoice/fetchViewList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'recurringinvoice',
      action: 'index',
      title: 'Recurring Invoices',
      icon: "",
      affix: false,
      search: false
    },
  },

  {
    path: "recurringinvoice/create",
    name: "RecurringInvoiceCreate",
    component: RecurringInvoiceCreate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      if (routeTo.query.clone_id) {
        // before this route is loaded
        store
          .dispatch("recurringinvoice/fetchList", {
            id:parseInt(routeTo.query.clone_id),
            type:'clone'})
          .then(() => {
            next();
          })
          .catch(() => {});
      } else if (routeTo.query.inv_id) {
        // before this route is loaded
        store
          .dispatch("recurringinvoice/fetchInvList", parseInt(routeTo.query.inv_id))
          .then(() => {
            next();
          })
          .catch(() => {});
      } else if (routeTo.query.customer_id) {
        // before this route is loaded
        store
          .dispatch("customer/fetchViewList", parseInt(routeTo.query.customer_id))
          .then(() => {
            next();
          })
          .catch(() => {});
      } else {
        next();
      }
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'recurringinvoice',
      action: 'create',
      title: 'Add New | Recurring Invoices',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "recurringinvoice/update/:id",
    name: "RecurringInvoiceUpdate",
    component: RecurringInvoiceUpdate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("recurringinvoice/fetchList",{
          id:parseInt(routeTo.params.id),
          type:'update'} )
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'recurringinvoice',
      action: 'update',
      title: 'Recurring Invoices',
      icon: "",
      affix: false,
      search: false
    },
  }
]
//  customer advance  route
export const customeradvance = [ //  payment update
  {
    path: "customeradvance",
    name: "CustomerAdvance",
    component: CustomerAdvance,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'index',
      id: 8,
      title: 'Customer Advances',
      icon: "fi flaticon-database-1",
      affix: true,
      hasChildren: false,
      hasParents: true,
      search: true
    },
  },
  {
    path: "customeradvance/create",
    name: "CustomerAdvanceCreate",
    component: CustomerAdvanceCreate,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'create',
      title: 'Add New | Customer Advances',
      icon: "",
      affix: false,
      search: false
    },

  },

  {
    path: "customeradvance/update/:id",
    name: "CustomerAdvanceUpdate",
    component: CustomerAdvanceUpdate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("customeradvance/fetchList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'update',
      title: 'Customer Advances',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "customeradvance/view/:id",
    name: "CustomerAdvanceView",
    component: CustomerAdvanceView,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("customeradvance/fetchviewList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        store
        .dispatch("settings/fetchinvoicesettings", {
          stg_menu: "Customer Advance",
          stg_name: "cus_adv_settings_details"
        })
        .then(() => {
          next();
        })

        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'index',
      title: 'Customer Advances',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "customeradvance/payment/:id",
    name: "CustomerAdvancePaymentForm",
    component: CustomerAdvancePaymentForm,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'create',
      title: 'Customer Advance Payment',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "customeradvance/refund/:id",
    name: "CustomerAdvanceRefund",
    component: CustomerAdvanceRefund,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'create',
      title: 'Customer Advance Refund',
      icon: "",
      affix: false,
      search: false
    },
  }
]
//  payments recived route
export const paymentsreceived = [ //  payment update
  {
    path: "payment",
    name: "Payment",
    component: Payment,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'index',
      id: 8,
      title: 'Payments Received',
      icon: "fi flaticon-download",
      affix: true,
      hasChildren: false,
      hasParents: true,
      search: true
    },
  },
  {
    path: "payment/create",
    name: "PaymentCreate",
    component: PaymentCreate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      if (routeTo.query.customer_id) {
        // before this route is loaded
        store
          .dispatch("customer/fetchViewList", parseInt(routeTo.query.customer_id))
          .then(() => {
            next();
          })
          .catch(() => {});
      } else {
        next();
      }

    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'create',
      title: 'Add New | Payments Received',
      icon: "",
      affix: false,
      search: false
    },

  },

  {
    path: "payment/update/:id",
    name: "PaymentUpdate",
    component: PaymentUpdate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("payment/fetchList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'update',
      title: 'Payments Received',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "payment/view/:id",
    name: "PaymentView",
    component: PaymentView,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("payment/fetchviewList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        store
        .dispatch("settings/fetchinvoicesettings", {
          stg_menu: "Payments Received",
          stg_name: "pymnt_settings_details"
        })
        .then(() => {
          next();
        })

        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'paymentsreceived',
      action: 'index',
      title: 'Payments Received',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "payment/refund/:id",
    name: "PaymentRefund",
    component: PaymentRefund,
    props: true,
    meta: {
      isheader: true,
      role: 'public',
      page: 'paymentsreceived',
      action: 'update',
      title: 'Payment Received Refund',
      icon: "",
      affix: false,
      search: false
    },
  }
]
//  creidt note route
export const creditnote = [
  // credit note

  {
    path: "credit",
    name: "Credit",
    component: Credit,
    props: true,
    meta: {
      isheader: true,
      id: 7,
      role: 'private',
      page: 'credit',
      action: 'index',
      title: 'Credit Notes',
      icon: "fi flaticon-note",
      affix: true,
      hasChildren: false,
      hasParents: true,
      search: true
    },
  },
  {
    path: "credit/create",
    name: "CreditCreate",
    component: CreditCreate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      if (routeTo.query.invoice_id) {
        store
          .dispatch(
            "credit/fetchCreditList", {
              id: parseInt(routeTo.query.invoice_id),
              page: 'invoice_id'
            }
          )
          .then(() => {
            next();
          })
          .catch(() => {});
      } else if (routeTo.query.return_id) {
        store
          .dispatch(
            "credit/fetchReturnCreditList", {
              id: parseInt(routeTo.query.return_id),
              return_id: routeTo.query.return_id
            }
          )
          .then(() => {
            next();
          })
          .catch(() => {});
      } else {
        next();
      }
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'credit',
      action: 'create',
      title: 'Add New | Credit Notes',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "credit/update/:id",
    name: "CreditUpdate",
    component: CreditUpdate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("credit/fetchList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'credit',
      action: 'update',
      title: 'Credit Notes',
      icon: "",
      affix: false,
      search: false
    },
  },

  {
    path: "credit/view/:id",
    name: "CreditView",
    component: CreditView,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("credit/fetchviewList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'credit',
      action: 'index',
      title: 'Credit Notes',
      icon: "",
      affix: false,
      search: false
    },
  }, {
    path: "credit/refund/:id",
    name: "CreditRefund",
    component: CreditRefund,
    props: true,
    meta: {
      isheader: true,
      role: 'public',
      page: 'credit',
      action: 'update',
      title: 'Credit Note Refund',
      icon: "",
      affix: false,
      search: false
    },
  }
];
//  gst filing route
export const gstfiling = [

  {
    path: "tax/filing",
    name: "GSTR1Overview",
    component: GSTR1Overview,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'gstfiling',
      action: 'index',
      end: true,
      id: 10,
      title: 'GST Filings',
      icon: "fi flaticon-bookmark",
      affix: true,
      hasChildren: false,
      hasParents: false,
      search: false
    },
  },
  {
    path: "tax/filing/transactions",
    name: "GSTR1Transaction",
    component: GSTR1Transaction,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'gstfiling',
      action: 'index',
      title: 'GST Filings',
      icon: "",
      affix: false,
      search: false
    },
  },
]
// discount coupon 
// export const discountcoupon = [{
//     path: "product/discountcoupon",
//     name: "DiscountCoupon",
//     component: DiscountCoupon,
//     props: true,
//     meta: {
//       isheader: true,
//       role: 'public',
//       id: 3,
//       page: 'discountcoupon',
//       action: 'index',
//       title: 'Coupons',
//       icon: "fi flaticon-gift",
//       affix: true,
//       hasChildren: false,
//       hasParents: true,
//       search: false
//     }
//   },
//   //end
//   {
//     path: "product/discountcoupon/update/:id",
//     name: "DiscountCouponUpdate",
//     component: DiscountCouponUpdate,
//     props: true,
//     beforeEnter(routeTo, routeFrom, next) {
//       // before this route is loaded
//       store
//         .dispatch("discountcoupon/fetchList", parseInt(routeTo.params.id))
//         .then(list => {
//           routeTo.params.list = list; // <--- Set the event we retrieved
//           next();
//         })
//         .catch(() => {});
//     },
//     meta: {
//       isheader: true,
//       role: 'public',
//       page: 'discountcoupon',
//       action: 'update',
//       title: 'Coupons',
//       icon: "",
//       affix: false,
//       search: false
//     },

//   },
//   {
//     path: "product/discountcoupon/create",
//     name: "DiscountCouponCreate",
//     component: DiscountCouponCreate,
//     props: true,
//     meta: {
//       isheader: true,
//       role: 'public',
//       title: 'Add New | Coupons',
//       page: 'discountcoupons',
//       action: 'create',
//       icon: "",
//       affix: false,
//       search: false
//     },
//   }
// ];
//  reports route
export const reports = [

  {
    path: "reports",
    name: "Reports",
    component: Reports,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'index',
      id: 11,
      title: 'Reports',
      icon: "la la-clone la-lg",
      affix: true,
      hasChildren: false,
      hasParents: false,
      search: false
    },
  },
  {
    path: "reports/salesperson",
    name: "SalesPerson",
    component: SalesPerson,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Sales By Salesperson',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "reports/salesperson/filter/:id",
    name: "SalesPersonFilter",
    component: SalesPersonFilter,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Sales By Salesperson',
      icon: "",
      affix: false,
      search: true
    },
  },
  {
    path: "reports/salesitem",
    name: "SalesItem",
    component: SalesItem,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Sales By Products',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "reports/salesitem/filter/:id",
    name: "SalesItemFilter",
    component: SalesItemFilter,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Sales By Products',
      icon: "",
      affix: false,
      search: true
    },
  },
  {
    path: "reports/salescustomer",
    name: "SalesCustomer",
    component: SalesCustomer,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Sales By Customer',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "reports/salescustomer/filer/:id",
    name: "SalesCustomerFilter",
    component: SalesCustomerFilter,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Sales By Customer',
      icon: "",
      affix: false,
      search: true
    },
  },
  {
    path: "reports/invoices",
    name: "InvoiceReport",
    component: InvoiceReport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Invoice Report',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "reports/estimate",
    name: "EstimateReport",
    component: EstimateReport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Quotation Report',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "reports/aging-details",
    name: "AgingDetailsReport",
    component: AgingDetailsReport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Aging Summary',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "reports/retinvdetails",
    name: "RetainerInvoiceDetailsReport",
    component: RetainerInvoiceDetailsReport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Retainer Invoice',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "reports/customerbalances",
    name: "CustomerBalancesReport",
    component: CustomerBalancesReport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Customer Balance',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "reports/customerbalances/filer/:id/:filter_by",
    name: "CustomerBalancesFilter",
    component: CustomerBalancesFilter,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Customer Balance',
      icon: "",
      affix: false,
      search: true
    },
  },
  {
    path: "reports/payment",
    name: "PaymentReport",
    component: PaymentReport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Invoice Payment Report',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "reports/tdsdetails",
    name: "TDSDetailsReport",
    component: TDSDetailsReport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'TDS Details Report',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "reports/tdsdetails/filer/:id",
    name: "TDSDetailsFilter",
    component: TDSDetailsFilter,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'TDS Details',
      icon: "",
      affix: false,
      search: true
    },
  },
  {
    path: "reports/taxsummary",
    name: "TaxSummary",
    component: TaxSummary,
    props: true,
    meta: {
      isheader: true,
      role: 'public',
      page: 'reports',
      action: 'salesreport',
      title: 'TAX Summary',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "reports/taxdetails/:id/:title",
    name: "TaxDetails",
    component: TaxDetails,
    props: true,
    meta: {
      isheader: true,
      role: 'public',
      page: 'reports',
      action: 'salesreport',
      title: 'Tax Details',
      icon: "",
      affix: false,
      search: false
    },
  },

  {
    path: "reports/bankcharges",
    name: "BankChargesReport",
    component: BankChargesReport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Bank Charges',
      icon: "",
      affix: false,
      search: false
    },
  }, {
    path: "reports/bankcharges/filer/:id",
    name: "BankChargesFilter",
    component: BankChargesFilter,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Bank Charges Details',
      icon: "",
      affix: false,
      search: true
    },
  }, {
    path: "reports/cndetails",
    name: "CreditNoteDetailsReport",
    component: CreditNoteDetailsReport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Credit Note',
      icon: "",
      affix: false,
      search: false
    },
  }, {
    path: "reports/paymentsreceived",
    name: "PaymentsReceivedReport",
    component: PaymentsReceivedReport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Payment Received',
      icon: "",
      affix: false,
      search: false
    },
  }, {
    path: "reports/refundhistory",
    name: "RefundHistoryReport",
    component: RefundHistoryReport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Refund History',
      icon: "",
      affix: false,
      search: false
    },
  }, {
    path: "reports/recurringinvoicedetails",
    name: "RecurringInvoiceReport",
    component: RecurringInvoiceReport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'salesreport',
      title: 'Recurring Invoice',
      icon: "",
      affix: false,
      search: false
    },
  }, {
    path: "reports/amccontract",
    name: "AmcContractReport",
    component: AmcContractReport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'reports',
      action: 'amccontractreport',
      title: 'AMC Contract',
      icon: "",
      affix: false,
      search: false
    },
  },

]
// dashboard route
export const dashboard = [

  //     // main pages
  {
    path: ":route/filtercreate",
    name: "FilterCreate",
    component: FilterCreate,
    props: true,
    meta: {
      isheader: true,
      role: 'public',
      page: 'filter',
      action: 'filtercreate',
      title: 'Custom Filter',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: ":route/filterupdate/:id",
    name: "FilterUpdate",
    component: FilterCreate,
    props: true,
    meta: {
      isheader: true,
      role: 'public',
      page: 'filter',
      action: 'filtercreate',
      title: 'Custom Filter',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "/",
    redirect: 'home/dashboard',
    meta: {
      isheader: true,
      page: 'dashboard',
      title: 'Dashboard',
      action: '',
      affix: false,
      search: false,
      role: 'public'
    }

  },

  {
    path: "home/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      isheader: true,
      page: 'dashboard',
      title: 'Dashboard',
      action: '',
      icon: "fi flaticon-home-1",
      affix: true,
      search: false,
      role: 'public'
    },
    props: true
  },
];
// permission route
export const permissionRoutes = {
  path: "/app",
  name: "Layout",
  component: Layout,
  children: [


  ]
}
export const settingsPage = [{
    path: "settings/theme",
    name: "UserTheme",
    component: UserTheme,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'generalpreferences',
      id: 10,
      title: 'User Themes',
      icon: "fi flaticon-diamond",
      affix: false,
      search: false
    },
  },
  {
    path: "users/roles",
    name: "UserRole",
    component: UserRole,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'userrole',
      id: 10,
      title: 'Roles',
      icon: "fi flaticon-users",
      affix: true,
      hasChildren: false,
      hasParents: false,
      search: false
    },
  },
  {
    path: "settings",
    name: "Settings",
    component: Settings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'generalpreferences',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: true,
      hasChildren: false,
      hasParents: false,
      search: false
    }
  },
  {
    path: "accounts/account",
    name: "AccountSettings",
    component: AccountSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'accounts',
      id: 10,
      title: 'Accounts',
      icon: "fi flaticon-bookmark",
      affix: true,
      hasChildren: false,
      hasParents: false,
      search: false
    },
  },
  {
    path: "openingbalance",
    name: "OpeningBalance",
    component: OpeningBalance,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'openingbalance',
      title: 'Opening Balances',
      icon: " fi flaticon-archive-1",
      affix: true,
      search: false

    },
  },
  {
    path: "openingbalance/type/:type",
    name: "OpeningBalanceType",
    component: OpeningBalance,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'openingbalance',
      title: 'Opening Balances',
      icon: " fi flaticon-archive-1",
      affix: false,
      search: false
    },
  },
  {
    path: "openingbalance/import",
    name: "OpeningBalanceImport",
    component: OpeningBalanceImport,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'openingbalance',
      title: 'Import | Settings | Sales',
      icon: "",
      affix: false,
      search: false
    },
  },

  {
    path: "settings/invoice",
    name: "InvoiceSettings",
    component: InvoiceSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'generalpreferences',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },

  {
    path: "settings/invoice/print",
    name: "InvoicePrintSettings",
    component: InvoicePrintSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'templates',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },

  {
    path: "settings/quotation/print",
    name: "QuotationPrintSettings",
    component: QuotationPrintSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'templates',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },


  {
    path: "settings/credit/print",
    name: "CreditPrintSettings",
    component: CreditPrintSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'templates',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },
  {
    path: "settings/customerstatement/print",
    name: "StatementPrintSettings",
    component: StatementPrintSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'templates',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },
  {
    path: "settings/product",
    name: "ProductSettings",
    component: ProductSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'generalpreferences',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },
  {
    path: "settings/retainer",
    name: "RetainerSettings",
    component: RetainerSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'generalpreferences',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },
  {
    path: "settings/amc",
    name: "AmcSettings",
    component: AmcSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'generalpreferences',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },
  {
    path: "settings/payment",
    name: "PaymentSettings",
    component: PaymentSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'generalpreferences',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },
  {
    path: "settings/customeradvance",
    name: "CustomerAdvanceSettings",
    component: CustomerAdvanceSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'generalpreferences',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },
  {
    path: "settings/recurring",
    name: "RecurringSettings",
    component: RecurringSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'generalpreferences',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },
  {
    path: "templates/printsettings",
    name: "Templates",
    component: Templates,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'templates',
      id: 10,
      title: 'Templates',
      icon: "la la-print la-lg",
      affix: true,
      hasChildren: false,
      hasParents: false,
      search: false
    },
  },
  {
    path: "templates/printsettings/:id",
    name: "TemplateUpdate",
    component: TemplateUpdate,
    props: true,

    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'templates',
      id: 12,
      title: 'Templates',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },
  {
    path: "templates/printsettings/:id",
    name: "RetailTemplatesUpdate",
    component: RetailTemplatesUpdate,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'templates',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },
  {
    path: "templates/printsettings/customer/:id",
    name: "CustomerTemplateUpdate",
    component: CustomerTemplateUpdate,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'templates',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },
  {
    path: "settings/quotation",
    name: "QuotationSettings",
    component: QuotationSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'generalpreferences',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },

  {
    path: "settings/credit",
    name: "CreditSettings",
    component: CreditSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'generalpreferences',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },
  {
    path: "settings/customerstatement",
    name: "CustomerStatement",
    component: CustomerStatement,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'generalpreferences',
      id: 12,
      title: 'Settings',
      icon: "fi flaticon-star",
      affix: false,
      search: false
    }
  },


  {
    path: "settings/invoice/settings",
    name: "Settings",
    component: Settings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'generalpreferences',
      id: 12,
      title: 'Invoice Settings',
      icon: "",
      affix: false,
      search: false
    },

  },
  {
    path: "taxes/taxrates",
    name: "TaxGroup",
    component: TaxGroup,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'taxes',
      id: 10,
      title: 'Taxes',
      icon: "la la-certificate la-lg",
      affix: true,
      hasChildren: false,
      hasParents: false,
      search: false
    },
  },
  {
    path: "currencies",
    name: "Currency",
    component: Currency,
    props: false,
    meta: {
      isheader: true,
      role: 'public',
      page: 'settings',
      action: 'currency',
      id: 10,
      title: 'Currencies',
      icon: "fi flaticon-database-1",
      affix: true,
      hasChildren: false,
      hasParents: false,
      search: false
    },
  },
  {
    path: "currencies/view/:id",
    name: "ExchangeRate",
    component: ExchangeRate,
    props: true,
    meta: {
      isheader: true,
      role: 'public',
      page: 'settings',
      action: 'exchangerate',
      title: 'Currencies | Exchange Rates ',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "currencies/exchangerate/import",
    name: "ExchangeRateImport",
    component: ExchangeRateImport,
    props: true,
    meta: {
      isheader: true,
      role: 'public',
      page: 'settings',
      action: 'exchangerate',
      title: 'Import |Exchange Rates',
      icon: "",
      affix: false,
      search: false
    },
  },
  {
    path: "reportingtag/reportingtag",
    name: "ReportingTag",
    component: ReportingTag,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'reportingtag',
      id: 10,
      title: 'Reporting Tags',
      icon: "fi flaticon-price-tag",
      affix: true,
      hasChildren: false,
      hasParents: false,
      search: false
    },
  },
  {
    path: "emailsettings",
    name: "EmailSettings",
    component: EmailSettings,
    props: true,
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'email',
      id: 10,
      title: 'Emails',
      icon: "fi flaticon-send",
      affix: true,
      search: false
    },
  }, {
    path: "emailsettings/emailupdate/:id",
    name: "EmailUpdate",
    component: EmailCreate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("settings/viewmailtemplate", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'email',
      id: 10,
      title: 'Emails',
      icon: "fi flaticon-send",
      affix: false,
      search: false
    },
  }, {
    path: "emailsettings/emailcreate",
    name: "EmailCreate",
    component: EmailCreate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      if (routeTo.query.clone_id) {
        store
          .dispatch("settings/viewmailtemplate", parseInt(routeTo.query.clone_id))
          .then(list => {
            routeTo.params.list = list; // <--- Set the event we retrieved
            next();
          })
          .catch(() => {});
      } else {
        next();
      }
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'email',
      id: 10,
      title: 'Emails',
      icon: "fi flaticon-send",
      affix: false,
      search: false
    },
  },
  {
    path: "users/roles/create",
    name: "UserRoleCreate",
    component: UserRoleCreate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("userrole/fetchList", parseInt(routeTo.query.clone_id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'userrole',
      id: 10,
      title: 'Add New | Roles',
      icon: "fi flaticon-users",
      affix: false,
      search: false
    },
  },
  {
    path: "users/roles/update/:id",
    name: "UserRoleUpdate",
    component: UserRoleUpdate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("userrole/fetchList", parseInt(routeTo.params.id))
        .then(list => {
          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      page: 'settings',
      action: 'userrole',
      title: 'User Roles',
      icon: "",
      affix: false,
      search: false
    },
  },


]
//  settings route
export const settingsRoutes = {
  path: "/settings",
  name: "Layout",
  component: Layout,
  children: []
}
//  permission to all route
export const constantRoutes = [

  {
    path: "/404",
    name: "404",
    component: Error,
    props: true
  },
  {
    path: "/500",
    name: "500",
    component: PermissonDenied,
    props: true
  },


  {
    path: "/",
    name: "Index",
    component: Index,
    props: true
  },
  {
    path: "/index",
    name: "Index",
    component: Index,
    props: true
  }

]
//  banking route
export const banking = [{
    path: "banking",
    name: "Banking",
    component: Banking,
    meta: {
      isheader: true,
      role: 'private',
      id: 14,
      page: 'banking',
      action: 'index',
      title: 'Banking',
      icon: "fi flaticon-house",
      affix: true,
      hasChildren: false,
      hasParents: false,
      search: false
    },
    props: true
  },
  {
    path: "banking/create",
    name: "BankingCreate",
    component: BankingCreate,

    meta: {
      isheader: true,
      role: 'private',
      title: 'Add New | Banking Account',
      icon: "",
      page: 'banking',
      action: 'create',
      affix: false,
      search: false
    },
    props: true
  },
  {
    path: "banking/update/:id",
    name: "BankingUpdate",
    component: BankingUpdate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      // before this route is loaded
      store
        .dispatch("banking/fetchList", parseInt(routeTo.params.id))
        .then(list => {

          routeTo.params.list = list; // <--- Set the event we retrieved
          next();
        })
        .catch(() => {});
    },
    meta: {
      isheader: true,
      role: 'private',
      title: 'Banking',
      page: 'banking',
      action: 'update',
      icon: "",
      affix: false,
      search: false
    },
  }
];
// 404 route
export const errorRoutes = {
  // Here's the new catch all route
  path: "*",
  redirect: {
    name: "404",
    params: {
      resource: "page"
    }
  },
}
// create route service
const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
})
// declare route
const router = createRouter()
// enable route reset
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router